import React from 'react';
import { Box, Typography } from '@mui/material';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { useAuth } from '../../../../contexts/AuthContext';
import { useUserOrganizations } from '../../hooks/useOrganization';
import OrgSwitcher from '../../components/OrgSwitcher';
import DataInputsStatus from '../../components/DataInputsStatus';

/**
 * IT Portal Hub — Mindmap branch 3, "Inputs → Org Data → IT Portal"
 *  The assistant's view of what data is flowing in for the active organization:
 *  live counts for connected inputs (surveys, TRLs, documents, health messages)
 *  and the client systems that connect during integration.
 */
function ITPortalHub() {
  const { user } = useAuth();
  const { organizations } = useUserOrganizations(user?.uid);
  const activeOrg = organizations[0] || null;

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1.5, flexWrap: 'wrap' }}>
        <CloudSyncIcon sx={{ color: 'primary.main', fontSize: 32 }} />
        <Typography variant="h4" sx={{ flexGrow: 1 }}>IT Portal — Org Data Inputs</Typography>
        <OrgSwitcher />
      </Box>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Live status of the data inputs REPSit.ai uses for {activeOrg?.name || 'your organization'} —
        survey responses, OE Conditions, documents, and health alerts — plus the organizational source
        systems (CAP, Safety, LMS, Coaching &amp; Observation) that connect during client integration
        to compute REPS scores, detect divergences, and trigger OE Health Alerts.
      </Typography>

      <DataInputsStatus organizationId={activeOrg?.id || null} />
    </Box>
  );
}

export default ITPortalHub;
